import { render, staticRenderFns } from "./PurchaseMobile.vue?vue&type=template&id=a5260e76&scoped=true"
import script from "./PurchaseMobile.vue?vue&type=script&lang=js"
export * from "./PurchaseMobile.vue?vue&type=script&lang=js"
import style0 from "./PurchaseMobile.vue?vue&type=style&index=0&id=a5260e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5260e76",
  null
  
)

export default component.exports